import { FC } from 'react';
import { Container, Wrapper } from './styled';

type Props = {
  children: any;
  empty?: boolean;
  responsive?: boolean;
};

const PageWrapper: FC<Props> = ({
  children,
  empty = false,
  responsive = true
}) => {
  return (
    <Container $empty={empty}>
      <Wrapper $responsive={responsive}>{children}</Wrapper>
    </Container>
  );
};

export default PageWrapper;
